import React, {Component} from 'react';

import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import StarIcon from 'material-ui/svg-icons/toggle/star';
import PersonIcon from 'material-ui/svg-icons/social/person';
import HistoryIcon from 'material-ui/svg-icons/action/history';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle'
import {RaisedButton, Dialog, TextField, FlatButton} from 'material-ui'
//import SettingsIcon from 'material-ui/svg-icons/action/settings'
import Avatar from 'material-ui/Avatar'
import {connect} from 'react-redux'

import ConnectedComponent from '../../shared/connecter/ConnectedComponent'
import {toggleLayout, toggleOrientationMode} from "../../game/config/settings/actions";
import {serializestore} from "../../store";



const styleHeader = {
    padding: '0 20px',
    color: '#777',
    fontSize: '16px',
    margin: 0,
    lineHeight: '30px'
}


class PlayerList extends ConnectedComponent {
    constructor() {
        super()
        this.subscribe('players')
    }

    playerStarts = (player) => {
        const first = this.store.players.get(player.id)
        this.store.players.remove(first)
        this.store.players.unshift(first)
    }

    render() {
        const players = this.store.players.toJSON().map(player => {

            const icon = player.image ? <Avatar src={player.image}/> : <PersonIcon/>

            return <MenuItem onTouchTap={() => this.playerStarts(player)} key={player.id}
                             leftIcon={icon}>{player.name}</MenuItem>
        })
        return <div>{players}</div>
    }
}

class DiceMode extends ConnectedComponent {
    constructor() {
        super()
        this.subscribe('settings')
    }

    toggleMode = () => {
        const prev = this.store.settings.get('mode')
        this.store.settings.set('mode', prev === 'dices' ? 'numbers' : 'dices')
    }

    render() {
        const toggled = this.store.settings.get('mode') === 'dices'
        return (<div>
            <h2 style={styleHeader}>Mode</h2>
            <Toggle label="Dés" toggled={toggled} onToggle={this.toggleMode}
                    style={{marginBottom: '16px', padding: '4px 20px'}}/>
        </div>)
    }
}

class Theme extends ConnectedComponent {
    constructor() {
        super()
        this.subscribe('settings')
    }

    toggleMode = () => {
        const prev = this.store.settings.get('theme')
        this.store.settings.set('theme', prev === 'default' ? 'crimson' : 'default')
    }

    render() {
        const crimson = this.store.settings.get('theme') === 'crimson'
        return (<div>
            <h2 style={styleHeader}>Theme</h2>
            <Toggle label="Theme" toggled={crimson} onToggle={this.toggleMode}
                    style={{marginBottom: '16px', padding: '4px 20px'}}/>
        </div>)
    }
}


const OrientationMode = connect(store => {
    return {
        orientation: store.settings.orientation,
        layout: store.settings.layout
    }
})(class extends Component {
    toggleMode = () => {
        this.props.dispatch(toggleOrientationMode(this.props.orientation === 'manual' ? 'auto' : 'manual'))
    }

    toggleOrientation = () => {
        this.props.dispatch(toggleLayout(this.props.layout === 'horizontal' ? 'vertical' : 'horizontal'))
        console.log('clip', this.props.layout)
    }

    render() {
        const portrait = this.props.layout === 'vertical'
        const orientation = this.props.orientation === 'auto'
        return (<div>
            <h2 style={styleHeader}>Orientation</h2>
            <Toggle label="Automatique" toggled={orientation} onToggle={this.toggleMode} style={{padding: '4px 20px'}}/>
            <Toggle label="Portrait" toggled={portrait} onToggle={this.toggleOrientation}
                    style={{marginBottom: '16px', padding: '4px 20px'}}/>
        </div>)
    }
})


class HistoryLink extends ConnectedComponent {
    constructor() {
        super()
        this.subscribe('settings')
    }

    changeRoute = () => {
        const prev = this.store.settings.get('route')
        console.log(prev)
        this.store.settings.set('route', prev === 'board' ? 'stats' : 'board')
    }

    render() {
        //const toggled = this.store.settings.get('mode') === 'dices'
        return (<MenuItem onTouchTap={this.changeRoute} leftIcon={<HistoryIcon/>}>Historique</MenuItem>)
    }
}

const styles = {
    exportButton: {
        position: 'absolute',
        bottom: 20,
        left: 20,
        display: 'block',
        width: 'calc(100% - 40px)'
    },
    closeButton: {
        position: 'absolute',
        bottom: 20,
        left: 20,
        display: 'block',
        width: 'calc(100% - 40px)'
    }
}

class DrawerComponent extends React.Component {
    constructor() {
        super()
        this.state = {
            dialog: false,
            export: false
        }
    }

    toggleDialog = (status) => this.setState({dialog: typeof status === 'boolean' ? status : !this.state.dialog})

    toggleExport = (status) => this.setState({export: typeof status === 'boolean' ? status : !this.state.export})

    newGame = () => {
        this.props.toggleMenu()
        this.props.newGameMenu()
    }

    render() {
        return (
            <Drawer open={this.props.open}>
                <AppBar title="Yamsy!" showMenuIconButton={false} onTitleTouchTap={this.props.toggleMenu}/>
                <MenuItem onTouchTap={this.newGame} leftIcon={<StarIcon/>}>Nouvelle Partie</MenuItem>
                <HistoryLink/>
                <DiceMode/>
                <Theme />
                <OrientationMode/>
                <h2 style={styleHeader}>Version 0.2.3</h2>
                <FlatButton style={styles.exportButton} label={'export'} onClick={() => this.toggleExport(true)}/>
                {/*<RaisedButton style={styles.closeButton} primary={true} label={'fermer'} onClick={() => {*/}
                    {/*const ipc = require('electron').ipcRenderer*/}
                    {/*ipc.send('close-main-window')*/}
                {/*}}/>*/}
                {this.state.export ? <Dialog open={this.state.export} onRequestClose={() => this.toggleExport(false)}>
                    <TextField fullWidth={true} name={'export'} value={JSON.stringify(serializestore())}/>
                </Dialog> : null}
            </Drawer>
        );
    }
}


export class RightDrawerComponent extends React.Component {


    render() {
        return (
            <Drawer openSecondary={true} open={this.props.open}>
                <AppBar title="Joueurs" titleStyle={{fontSize: '16px'}} showMenuIconButton={false}
                        onTitleTouchTap={this.props.toggleMenu}/>
                <PlayerList/>
            </Drawer>
        );
    }
}


export default DrawerComponent;



// WEBPACK FOOTER //
// ./src/layout/components/DrawerComponent.jsx